export enum AdicionalType {
	MensajeSimpleFacturaPDF = 1,
        LogoPropio = 2,
        DominioPropio = 3,
        Recibidos = 4
}
